import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormsModule, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import dayjs from 'dayjs';
import { ApiService } from 'src/app/services';
import { WorkingContractTemplateCareerPlan } from 'src/app/models/working_contract_template_career_plan.model';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDatepickerToggle } from '@angular/material/datepicker';
import { MatLabel } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-select-career-plan-template-dialog',
  templateUrl: './select-career-plan-template-dialog.component.html',
  styleUrls: ['./select-career-plan-template-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatFormField,
    MatSelect,
    FormsModule,
    MatOption,
    MatDialogActions,
    MatButton,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatDatepickerToggle,
    MatLabel,
    ReactiveFormsModule,
  ],
})
export class SelectCareerPlanTemplateDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<SelectCareerPlanTemplateDialogComponent>>(MatDialogRef);
  private api = inject(ApiService);
  private fb = inject(FormBuilder);

  templates!: WorkingContractTemplateCareerPlan[];
  minDate: Date = dayjs().add(1, 'day').startOf('day').toDate();
  form: FormGroup;

  constructor() {
    this.form = this.fb.group({
      templateId: ['', Validators.required],
      currentFrom: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.fetchWorkingContractTemplateCareerPlans();
  }

  submit(): void {
    if (this.form.invalid) return;

    this.dialogRef.close({
      templateId: this.form.value['templateId'],
      current_from: this.form.value['currentFrom'],
    });
  }

  private fetchWorkingContractTemplateCareerPlans(): void {
    this.api.getCareerPlanTemplates().subscribe((data): void => {
      this.templates = data.data;
    });
  }
}
